import { useRef, useState } from "react";
import { Upload, FileText, Loader2, ExternalLink } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { imgUrl, fmtDate } from "@/lib/format";
import { toast } from "sonner";

export default function InvoicePanel({ order, onUpdated }) {
  const fileRef = useRef();
  const [uploading, setUploading] = useState(false);
  const invoices = order.invoices || [];

  const upload = async (file) => {
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post(`/orders/${order.id}/invoice`, fd, { headers: { "Content-Type": "multipart/form-data" } });
      onUpdated?.(data);
      toast.success("Fatura yüklendi");
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail) || "Yükleme başarısız");
    } finally {
      setUploading(false);
      if (fileRef.current) fileRef.current.value = "";
    }
  };

  return (
    <div className="bg-surface border border-border rounded-md p-4" data-testid="invoice-panel">
      <div className="flex items-center justify-between mb-3">
        <div className="text-[10px] tracking-luxe uppercase text-gold">Kesilen Fatura</div>
        <input ref={fileRef} type="file" accept=".pdf,image/*" className="hidden" data-testid="invoice-upload-input" onChange={(e) => upload(e.target.files[0])} />
        <button
          data-testid="invoice-upload-button"
          onClick={() => fileRef.current?.click()}
          disabled={uploading}
          className="flex items-center gap-2 px-3 h-9 text-sm border border-border rounded-md hover:border-gold transition-colors disabled:opacity-60"
        >
          {uploading ? <Loader2 className="animate-spin" size={15} /> : <Upload size={15} />} Fatura Yükle
        </button>
      </div>
      {invoices.length === 0 ? (
        <p className="text-xs text-muted-foreground">Henüz fatura yüklenmemiş. PDF veya görsel yükleyebilirsiniz.</p>
      ) : (
        <div className="space-y-2">
          {invoices.map((inv) => (
            <a
              key={inv.id}
              href={imgUrl(inv.url)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`invoice-link-${inv.id}`}
              className="flex items-center gap-3 bg-obsidian border border-border rounded-md px-3 py-2 hover:border-gold transition-colors"
            >
              <FileText size={16} className="text-gold shrink-0" />
              <div className="min-w-0 flex-1">
                <div className="text-sm text-foreground truncate">{inv.filename || "Fatura"}</div>
                <div className="text-[11px] text-muted-foreground">
                  {inv.uploaded_role === "admin" ? "ORSE GOLD" : "Müşteri"} · {fmtDate(inv.uploaded_at)}
                </div>
              </div>
              <ExternalLink size={14} className="text-muted-foreground" />
            </a>
          ))}
        </div>
      )}
    </div>
  );
}
